<template>
  <v-app
    :style="{ background: isWidget ? 'transparent' : '' }"
    class="theme--dark"
  >
    <Login v-if="!isWidget" app />
    <Logout v-if="!isWidget" app />

    <Header v-if="showHeader"></Header>
    <Nav :scroll_position="scrollPosition" v-if="!isWidget" />
    <v-content>
      <router-view></router-view>
    </v-content>
    <snackbar />
    <Footer v-if="showHeader"></Footer>
  </v-app>
</template>

<script>
import Nav from "./components/Nav";
import Login from "./components/Login";
import Logout from "./components/Logout";
import Snackbar from "./components/Snackbar";
import Header from "./components/Header";
import Footer from "./components/Footer";
export default {
  components: { Nav, Login, Logout, Snackbar, Header, Footer },
  name: "App",
  data() {
    return {
      isWidget: false,
      showHeader: true,
      scrollPosition: null,
    };
  },
  created() {
    document.title = "Hihat";
  },
  mounted: function() {
    this.$store.dispatch("get_settings_data");
    this.$store.dispatch("get_num_trades");
    this.$store.dispatch("get_hicards_data");
    //let self=this;

    /*setInterval(function(){
      self.$store.dispatch("get_num_trades");
      self.$store.dispatch("get_num_cards");
    },30000);*/
    window.addEventListener("scroll", this.updateScroll);
  },
  watch: {
    $route: {
      handler: function(route) {
        if (
          route.path === "/widget_do" ||
          route.path === "/widget_hc" ||
          route.path === "/widget_kon" ||
          route.path === "/widget_rocker" ||
          route.path === "/widget_hp" ||
          route.path === "/widget_vi" ||
          route.path === "/widget_cd" ||
          route.path === "/widget_flak" ||
          route.path === "/widget_24" ||
          route.path === "/gg2" ||
          route.path === "/gg3" ||
          route.path === "/gg" ||
          route.path === "/wtt"
        ) {
          this.isWidget = true;
          this.showHeader = false;
        } else if (
          route.name === "Inventory" ||
          route.name === "donation_overlays"
        ) {
          this.isWidget = false;
          this.showHeader = false;
        } else {
          this.isWidget = false;
          this.showHeader = true;
        }
      },
      deep: true,
      immediate: true,
    },
    "$store.state.STREAMER.SID": function(sid, oldSid) {
      if (sid !== 0) {
        this.$socket.emit("trades_and_cards_updates", sid);
      } else {
        this.$socket.emit("leave_trades_and_cards_updates", oldSid);
      }
    },
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
  },
  sockets: {
    error: function(data) {
      console.log(data);
    },
    err: function(data) {
      console.log(data);
    },
    trades: function() {
      this.$store.dispatch("get_num_trades");
    },
  },
  destroy() {
    window.removeEventListener("scroll", this.updateScroll);
  },
};
</script>

<style>
.background_grad {
  background: linear-gradient(
    315deg,
    rgba(10, 10, 9, 1) 0%,
    rgba(45, 45, 45, 1) 100%
  );
}
canvas {
  outline: none;
}
button {
  outline: none !important;
}
.fullscreen-bg__video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  margin: 0 !important;
  object-fit: cover;
  padding: 0 !important;
  z-index: 1 !important;
  pointer-events: none;
  opacity: 0.1 !important;
}
.ac_textarea > * textarea {
  overflow: hidden !important;
  font-size: 11px;
  line-height: 15px !important;
  background: transparent;
  padding-left: 6px !important;
}
.v-input__slot {
  background: transparent !important;
}
.centered_text > * input {
  text-align: center !important;
}
.suggestionBox > * input {
  font-size: 0.8em;
  padding-top: 0;
}
.v-dialog--fullscreen {
  border-radius: 0;
  margin: 0;
  height: 100%;
  position: fixed;
  overflow: hidden !important;
  left: 0;
}
::-webkit-scrollbar {
  width: 10px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #ffffff;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: #757575;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #373834;
}
.hide_my_spin > * input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}
.container {
  max-width: 100% !important;
  overflow-x: hidden !important;
}
.digi {
  font-family: "Galindo", cursive;
  font-weight: 500;
}
.anton {
  font-family: "Anton", sans-serif;
}
</style>
